const channelLinks = ["直播带货", "综艺娱乐", "新消费", "商业动向", "娱乐人物", "品牌公关"];
const guideLinks = [
  { href: "#principles", label: "追踪准则" },
  { href: "#timeline", label: "事件脉络" },
  { href: "#responses", label: "各方回应" },
  { href: "#faq", label: "常见问题" },
];

export default function Footer() {
  return (
    <footer className="border-t border-background-200 bg-background-200/60">
      <div className="container-x py-10 md:py-14">
        <div className="grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-4">
          <div>
            <a href="#top" className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50">
                <i className="ri-flashlight-fill text-lg" aria-hidden="true"></i>
              </span>
              <span className="font-heading text-lg font-black tracking-tight text-foreground-950">沸点追踪</span>
            </a>
            <p className="mt-4 text-sm leading-relaxed text-foreground-600">
              专注最新黑料、新事件与新进展的热点事件追踪站。先理时间线，再下结论；核实优先，追踪不掉线。
            </p>
            <div className="mt-4 flex gap-2">
              {["ri-weibo-line", "ri-wechat-line", "ri-tv-2-line", "ri-rss-line"].map((ic) => (
                <a
                  key={ic}
                  href="#subscribe"
                  aria-label="关注沸点追踪社交媒体"
                  className="flex h-9 w-9 items-center justify-center rounded-md border border-background-300 bg-background-100 text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-600"
                >
                  <i className={`${ic} text-base`} aria-hidden="true"></i>
                </a>
              ))}
            </div>
          </div>

          <nav aria-label="频道分类">
            <h2 className="text-sm font-bold text-foreground-950">追踪频道</h2>
            <ul className="mt-4 grid grid-cols-2 gap-x-3 gap-y-2 text-sm text-foreground-600">
              {channelLinks.map((c) => (
                <li key={c}>
                  <a href="#channels" className="whitespace-nowrap transition-colors hover:text-primary-600">
                    {c}
                  </a>
                </li>
              ))}
            </ul>
          </nav>

          <nav aria-label="浏览引导">
            <h2 className="text-sm font-bold text-foreground-950">浏览引导</h2>
            <ul className="mt-4 space-y-2 text-sm text-foreground-600">
              {guideLinks.map((g) => (
                <li key={g.label}>
                  <a href={g.href} className="transition-colors hover:text-primary-600">
                    {g.label}
                  </a>
                </li>
              ))}
              <li>
                <a href="#subscribe" className="transition-colors hover:text-primary-600">
                  订阅新料
                </a>
              </li>
            </ul>
          </nav>

          <div>
            <h2 className="text-sm font-bold text-foreground-950">联系我们</h2>
            <p className="mt-4 text-sm leading-relaxed text-foreground-600">
              如需提交线索或进行纠错反馈，欢迎发邮件或在页面表单中留言。
            </p>
            <a
              href="mailto:hello@fudiantrace.readdy.site"
              className="mt-3 inline-flex items-center gap-2 text-sm font-semibold text-primary-600 transition-colors hover:text-primary-700"
            >
              <i className="ri-mail-line" aria-hidden="true"></i>
              hello@fudiantrace.readdy.site
            </a>
            <p className="mt-3 text-xs leading-relaxed text-foreground-500">
              我们重视内容的可核实性，涉及隐私或未经证实的说法，一律不做扩散传播。
            </p>
          </div>
        </div>

        <div className="mt-10 flex flex-col gap-3 border-t border-background-300 pt-6 text-xs text-foreground-500 sm:flex-row sm:items-center sm:justify-between">
          <p>© {new Date().getFullYear()} 沸点追踪 · 关注最新进展，追踪不掉线。</p>
          <div className="flex flex-wrap gap-x-4 gap-y-1">
            <a href="#top" className="transition-colors hover:text-primary-600">回到顶部</a>
            <a href="#principles" className="transition-colors hover:text-primary-600">内容原则</a>
            <a href="#subscribe" className="transition-colors hover:text-primary-600">线索提交</a>
          </div>
        </div>
      </div>
    </footer>
  );
}